import {extend} from 'vee-validate'
import i18n from "@/i18n/i18n"

import {
    required,
    email,
    is_not,
    confirmed,
    numeric,
    double,
    max_value,
    regex,
    min,
    max,
    integer
} from 'vee-validate/dist/rules'

extend('required', {
    ...required,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.required', {name: fieldName})
    }
})

extend('minmax', {
    validate(value, {min, max}) {
        const text = value.replace(/\s/g, '')
        return text.length >= min && text.length <= max
    },
    params: ['min', 'max'],
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.minmax', {
            minimum: placeholders.min,
            maximum: placeholders.max
        })
    }
})

extend('max_value', {
    ...max_value,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.max_value', {
            max: placeholders.max
        })
    }
})

extend('min', {
    ...min,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.min', {
            min: placeholders.length
        })
    }
})

extend('max', {
    ...max,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.max', {
            max: placeholders.length
        })
    }
})

extend('email', {
    ...email,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.email')
    }
})

extend('is_not', {
    ...is_not,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.is_not')
    }
})

extend('confirmed', {
    ...confirmed,
    message: (fieldName, placeholders) => {
        return i18n.t('validationErrors.confirmed', {
            target: placeholders.target
        })
    }
})

extend('numeric', {
    ...numeric,
    message: (fieldName) => {
        return i18n.t('validationErrors.numeric', {name: fieldName})
    }
})

extend('integer', {
    ...integer,
    message: (name) => {
        return i18n.t('validationErrors.integer', {name})
    }
})

extend('floatOrInteger', {
    validate: (value) => {
        return /^\d+(\.\d{1,2})?$/.test(value)
    },
    message: (name) => {
        return i18n.t('validationErrors.floatOrInteger', {name})
    }
})

extend('double', {
    ...double,
    message: (fieldName) => {
        return 'test'
    }
})

extend('checkNumberOrNonInteger', {
    validate: value => {
        return numeric.validate(value) || double.validate(value)
    },
    message: (fieldName) => {
        return i18n.t('validationErrors.numeric', {name: fieldName})
    }
})

extend('negativeNumber', {
    validate: value => {
        return Number(value) >= 0
    },
    message: (fieldName) => {
        return i18n.t('validationErrors.negativeNumber', {name: fieldName})
    }
})

extend('maxNum', {
    params: ['target'],
    validate: (value, {target}) => {
        return Number(value) <= ~~target
    },

    message: (name, {target}) => {
        return i18n.t('validationErrors.maxNum', {target})
    }
})

extend('minNum', {
    params: ['target'],
    validate: (value, {target}) => {
        return Number(value) >= ~~target
    },

    message: (name, {target}) => {
        return i18n.t('validationErrors.minNum', {target})
    }
})

extend('gte', {
  params: ['target', 'targetName'],
  validate(value, { target }) {
    return Number(value) >= Number(target)
  },
  message: (name, {targetName}) => {
    console.log(targetName)
    return i18n.t('validationErrors.gte', {targetName})
  }
})

extend('ip', {
    validate: value => {
        const regexIpv4 = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/
        const regexIpv6 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
        return regexIpv4.test(value) || regexIpv6.test(value)
    },

    message: () => {
        return i18n.t('validationErrors.ip')
    }
})

extend('url', {
    validate: value => {
        const regexUrl = /^(https?):\/\/([\w\-]+\w?\.)+([\w\-]+)(:[0-9]+)?((\/[\w\-\%]+)+)?(\.[A-z]*)?\/?([?][\w=&]*)?([#][\w=&]*)?$/
        return regexUrl.test(value)
    },

    message: () => {
        return i18n.t('validationErrors.url')
    }
})

extend('string', {
    validate: value => {
        return typeof value === 'string'
    },

    message: () => {
        return i18n.t('validationErrors.string')
    }
})

extend('regex', {
    ...regex,
    message: () => {
        return i18n.t('validationErrors.incorrect_value')
    }
})

extend('checkCardNumber', {
    validate: value => {
        return value.replace(/\s/g, '').split('').length === 16 || value.replace(/\s/g, '').split('').length === 17
    },

    message: () => {
        return i18n.t('validationErrors.incorrect_card_number')
    }
})

extend('checkCvvNumber', {

    validate: value => {
        return value.replace(/\s/g, '').split('').length === 3 || value.replace(/\s/g, '').split('').length === 4
    },

    message: () => {
        return i18n.t('validationErrors.incorrect_card_number')
    }
})

extend('checkDomainName', {
    validate: value => {
        const regexUrl = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/
        return regexUrl.test(value)
    },

    message: () => {
        return i18n.t('validationErrors.incorrect_value')
    }
})

extend('phone', {
    validate: value => {
        const regexPhone = /^([+0-9]+)$/
        return regexPhone.test(value)
    },

    message: () => {
        return i18n.t('validationErrors.incorrect_phone_number')
    }
})

extend('uniqueInArray', {
    params: ['items', 'field'],
    validate(value, { items, field }) {
        if (!Array.isArray(items) || !field) {
            return true
        }

        const count = items.filter(item => item && item[field] === value).length
        return count <= 1
    },
    message: (name) => {
        return i18n.t('validationErrors.unique', { name })
    }
})
